import { InAppMessageEligibilityEvaluation } from "../../../core/internal/evaluation/evalautor/iam/eligibility/InAppMessageEligibilityEvaluation"
import { InAppMessageEligibilityRequest } from "../../../core/internal/evaluation/evalautor/iam/eligibility/InAppMessageEligibilityRequest"
import UserEvent, { TrackEvent } from "../../../core/internal/event/UserEvent"
import { InAppMessage } from "../../../core/internal/model/model"
import Workspace from "../../../core/internal/workspace/Workspace"

import WorkspaceFetcher from "../../../core/internal/workspace/WorkspaceFetcher"
import { InAppMessageEvaluateProcessor } from "../evaluation/InAppMessageEvaluateProcessor"
import { InAppMessageEventMatcher } from "./InAppMessageEventMatcher"
import { InAppMessageTrigger } from "./InAppMessageTrigger"

export class InAppMessageTriggerDeterminer {
  constructor(
    private readonly workspaceFetcher: WorkspaceFetcher,
    private readonly eventMatcher: InAppMessageEventMatcher,
    private readonly evaluateProcessor: InAppMessageEvaluateProcessor
  ) {}

  determine(event: UserEvent): InAppMessageTrigger | null {
    const trackEvent = UserEvent.isTrackEvent(event) ? event : null
    if (!trackEvent) return null

    const workspace = this.workspaceFetcher.get()
    if (!workspace) return null

    for (const inAppMessage of workspace.getInAppMessages()) {
      const matches = this.eventMatcher.matches(workspace, inAppMessage, trackEvent)
      if (!matches) {
        continue
      }

      const evaluation = this.evaluate(workspace, inAppMessage, trackEvent)
      if (evaluation.isEligible) {
        return new InAppMessageTrigger(inAppMessage, evaluation.reason, trackEvent)
      }
    }

    return null
  }

  private evaluate(
    workspace: Workspace,
    inAppMessage: InAppMessage,
    event: TrackEvent
  ): InAppMessageEligibilityEvaluation {
    const request = new InAppMessageEligibilityRequest(workspace, event.user, inAppMessage, event.timestamp)
    return this.evaluateProcessor.process("TRIGGER", request)
  }
}
